import { c as _c } from "react/compiler-runtime";
/**
 * Single play-page observability entry point for pandatv-pc: the existing
 * page-health metrics plus the new video QoE stream.
 *
 * `usePlayMetrics` stays gated on adult streams (unchanged) and gains the
 * RT-aware element getter it was missing (in RT mode `ivsPlayer` is null, so it
 * previously collected nothing). `useVideoQoe` runs for every stream including
 * adult — video QoE is a full census baseline.
 */

import type { PlayInfo } from '@module/apis/client-side/live/type';
import useOldPlayerStore, { getIVSMediaPlayer } from '@module/stores/useOldPlayerStore';
import type { RefObject } from 'react';
import type { RemoteVideoStatsSource } from '../../video/types';
import { useVideoQoe } from '../../video/useVideoQoe';
import { usePlayMetrics } from './index';
interface UsePlayObservabilityOptions {
  playInfo: PlayInfo;
  isRT: boolean;
  videoElementRef: RefObject<HTMLVideoElement | null> | null;
  getRemoteVideoStream?: () => RemoteVideoStatsSource | null;
}
export function usePlayObservability(t0) {
  const $ = _c(10);
  const {
    playInfo,
    isRT,
    videoElementRef,
    getRemoteVideoStream
  } = t0;
  let t1;
  if ($[0] !== isRT || $[1] !== videoElementRef) {
    t1 = () => isRT ? videoElementRef?.current : getIVSMediaPlayer(useOldPlayerStore.getState().ivsPlayer)?.getHTMLVideoElement();
    $[0] = isRT;
    $[1] = videoElementRef;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  let t2;
  if ($[3] !== playInfo.media.isAdult || $[4] !== t1) {
    t2 = {
      getVideoElement: t1,
      disabled: playInfo.media.isAdult
    };
    $[3] = playInfo.media.isAdult;
    $[4] = t1;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  usePlayMetrics(t2);
  let t3;
  if ($[6] !== getRemoteVideoStream || $[7] !== playInfo || $[8] !== videoElementRef) {
    t3 = {
      playInfo,
      videoElementRef,
      getRemoteVideoStream
    };
    $[6] = getRemoteVideoStream;
    $[7] = playInfo;
    $[8] = videoElementRef;
    $[9] = t3;
  } else {
    t3 = $[9];
  }
  useVideoQoe(t3);
}